(function(){
    angular
        .module('appback')
        .directive('ngChatroom', ngChatroom);

        ngChatroom.$inject = ['socket','$timeout'];
        function ngChatroom(socket,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/web/app/views/chatroom.html',
		        scope: {
                  //ngModel : '=',
                  rc: '=',
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	scope.mensajes = [];
		            	scope.chatCerrado = true;
		            	scope.unchat = false;
		            	scope.numeroSinleer = 0;
		            	//Disponible en: http://es.wikipedia.org/wiki/Archivo:Sound-of-dog.ogg
						var rutaLadrido = 'https://ulab.uranovet.com/backend/uploads/sounddog.ogg';
						 
						//Creamos el elemento Audio
						var sonido = new Audio();
						//Para el ejemplo usaremos una console, la veremos en un momento
						//La ruta la asignamos después de los eventos para
						//asegurarnos de que se disparen en el momento justo
						sonido.src = rutaLadrido;

		            	scope.gifs = {
		            		"[moco]":'<img src="/backend/uploads/moco.gif" class="chatgif" />',
		            		"[pedo]":'<img src="/backend/uploads/pedo.gif" class="chatgif" />',
		            		"[baile]":'<img src="/backend/uploads/baile.gif" class="chatgif" />',
		            		"[guino]":'<img src="/backend/uploads/guino.gif" class="chatgif" />',
		            		"[muerte]":'<img src="/backend/uploads/muerte.gif" class="chatgif" />',
		            		"[llorar]":'<img src="/backend/uploads/llorar.gif" class="chatgif" />',
		            		"[escalar]":'<img src="/backend/uploads/escalar.gif" class="chatgif" />',
		            		"[padel]":'<img src="/backend/uploads/padel.gif" class="chatgif" />',
		            		"[excelente]":'<img src="/backend/uploads/excelente.gif" class="chatgif" />',
		            		"[arbusto]":'<img src="/backend/uploads/arbusto.gif" class="chatgif" />',
		            		"[disco]":'<img src="/backend/uploads/disco.webp" class="chatgif" />',
		            		"[chesterchetos]":'<img src="/backend/uploads/chester.gif" class="chatgif" />',
		            	}
		            	socket.on('chat:mensaje', function (data) {
		            		console.log(data);
		            		$timeout(function(){
		            			if($('.direct-chat-primary').find('.fa-plus').length>0){
		            				$('.direct-chat-primary').find('.fa-plus').closest("button").click();
		            			}
		            		})
	            			/*if($('.direct-chat-primary').find('.fa-plus').length>0){
	            				$('.direct-chat-primary').find('.fa-plus').closest("button").click();
	            			}*/
		            		if(data.data.msg){
			            		if(typeof(scope.gifs[data.data.msg]) != 'undefined'){
			            			data.data.msg = scope.gifs[data.data.msg];
			            		}
			            	}
			            	scope.mensajes.push(data.data);
			            	$timeout(function(){
			            		var div = $(".direct-chat-messages");
    							div.scrollTop(div.prop('scrollHeight'));
			            	},100)
		            		if(scope.rc.userName != data.data.user){
			            		scope.numeroSinleer++;
								//sonido.play();
			            	}
			            	if(!scope.unchat){
		            			scope.unchat = true;
			            	}
				        });

				        scope.revisarAltura = function(){
				        	$timeout(function(){
				        		var div = $(".direct-chat-messages");
								div.scrollTop(div.prop('scrollHeight'));
				        	},100)
		            		
			        	}

				        scope.enviarChat = function(){
				        	console.log("Enviando..");
                    		socket.emit('chat:mensaje', {user:scope.rc.userName,'msg':scope.mensajetexto});
                    		scope.mensajetexto = "";
				        }
				        scope.reiniciarContador = function(){
		            		scope.numeroSinleer = 0;
				        }
						scope.openChat = function() {
							document.querySelector(".direct-chat").style.right = "0";
							document.querySelector('.main_content_iner').classList.add('back-tablon')
							document.querySelector('.main_content_iner').classList.add('back-chat')
							closeTablon(document.querySelector('.back-tablon'))
						}
						scope.closeChat = function() {
							document.querySelector(".direct-chat").style.right = "-100%";
							document.querySelector('.main_content_iner').classList.remove('back-tablon')
							document.querySelector('.main_content_iner').classList.remove('back-chat')
						}
			        });
		        }
          }
      }
})();